<script setup lang="ts">
import type { Component } from "vue";
import LeglSpinner from "../../components/LeglSpinner.vue";
import type { CompanyDetails, Step } from "../types";
import ClientRequestClosedStep from "./ClientRequestClosedStep.vue";
import ClientRequestCompleteStep from "./ClientRequestCompleteStep.vue";
import ClientRequestUnavailableStep from "./ClientRequestUnavailableStep.vue";

const props = defineProps<{
  isDesktop?: boolean;
  isInitialised: boolean;
  clientRequestError: boolean;
  clientRequestClosed: boolean;
  clientRequestComplete: boolean;
  currentStep: Step<any> | null;
  stepComponents: Record<string, Component>;
  companyDetails: CompanyDetails | null;
  stepSubmitting?: boolean;
}>();

const emit = defineEmits<{
  (e: "step:complete", step: string): void;
  (e: "step:back"): void;
}>();
</script>

<template>
  <div
    v-if="(isInitialised && currentStep) || clientRequestError"
    class="current-step-container"
  >
    <div class="current-step">
      <ClientRequestUnavailableStep v-if="clientRequestError" />
      <ClientRequestCompleteStep
        v-else-if="clientRequestComplete"
        :companyDetails="companyDetails"
      />
      <ClientRequestClosedStep
        v-else-if="clientRequestClosed"
        :companyDetails="companyDetails"
      />
      <keep-alive v-else-if="currentStep">
        <component
          :is="stepComponents[currentStep.component]"
          :currentStep="currentStep"
          :isDesktop="isDesktop"
          :stepSubmitting="stepSubmitting"
          @step:complete="emit('step:complete', currentStep.name)"
          @step:back="emit('step:back')"
        />
      </keep-alive>
    </div>
  </div>
  <template v-else>
    <div class="legl-spinner-container">
      <LeglSpinner />
    </div>
  </template>
</template>

<style scoped lang="scss">
.current-step-container {
  box-shadow: 0px 0px 250px 0px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-self: center;
  width: 100%;
  margin: $spacing-s 0;
  max-width: 720px;
}
.current-step {
  padding: $spacing-m $spacing-s;
  @include elevation-100;
  border-radius: $spacing-xs;
  width: 100%;
  @media only screen and (min-width: 768px) {
    padding: $spacing-m;
  }
}
.legl-spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
